module.exports = __webpack_public_path__ + "static/media/ally_pro_8.28ca7a6e.jpg";